import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  blurOnWheel (event) {
    const input = event.target.closest('input[type="number"]')
    if (!input) return

    input.blur()
  }
}
